import React from 'react';
import { siteConfig } from '../../data/siteConfig';
import './Privacy.css';

const Privacy = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="privacy">
      <div className="container-narrow">
        <div className="privacy__header">
          <h1 className="privacy__title">Privacy Policy</h1>
          <p className="privacy__subtitle">
            Last updated: January 2026
          </p>
        </div>

        <div className="privacy__content">
          <section className="privacy__section">
            <h2>1. Information We Collect</h2>
            <p>
              {siteConfig.brand.companyName} ("we," "our," or "us") operates the 
              {siteConfig.brand.name} website. This page informs you of our policies 
              regarding the collection, use, and disclosure of personal data when you 
              use our service.
            </p>
            
            <h3>Personal Information</h3>
            <p>
              We may collect personal information that you voluntarily provide to us when you:
            </p>
            <ul>
              <li>Visit our website</li>
              <li>Contact us via email or phone</li>
              <li>Subscribe to our newsletter or updates</li>
              <li>Participate in surveys or promotions</li>
            </ul>

            <h3>Usage Data</h3>
            <p>
              We may also collect information on how the service is accessed and used. 
              This usage data may include information such as your computer's Internet 
              Protocol address (e.g., IP address), browser type, browser version, 
              the pages of our service that you visit, the time and date of your visit, 
              the time spent on those pages, and other diagnostic data.
            </p>
          </section>

          <section className="privacy__section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the collected data for various purposes:</p>
            <ul>
              <li>To provide and maintain our service</li>
              <li>To notify you about changes to our service</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information to improve our service</li>
              <li>To monitor the usage of our service</li>
              <li>To detect, prevent and address technical issues</li>
              <li>To provide you with news and updates about {siteConfig.brand.name}</li>
            </ul>
          </section>

          <section className="privacy__section">
            <h2>3. Cookies and Tracking</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on 
              our service and store certain information. Cookies are files with a 
              small amount of data which may include an anonymous unique identifier.
            </p>
            
            <h3>Types of Cookies We Use</h3>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
              <li><strong>Preference Cookies:</strong> Remember your preferences and settings</li>
            </ul>

            <p>
              You can instruct your browser to refuse all cookies or to indicate when 
              a cookie is being sent. However, if you do not accept cookies, you may 
              not be able to use some portions of our service.
            </p>
          </section>

          <section className="privacy__section">
            <h2>4. Data Security</h2>
            <p>
              The security of your data is important to us, but remember that no method 
              of transmission over the Internet, or method of electronic storage is 100% 
              secure. While we strive to use commercially acceptable means to protect 
              your personal data, we cannot guarantee its absolute security.
            </p>
          </section>

          <section className="privacy__section">
            <h2>5. Third-Party Services</h2>
            <p>
              We may employ third-party companies and individuals to facilitate our 
              service, provide the service on our behalf, perform service-related 
              services, or assist us in analyzing how our service is used.
            </p>
            
            <h3>Google Services</h3>
            <p>
              We use Google Maps for location services and Google Analytics for website 
              analytics. These services have their own privacy policies governing the 
              use of your information.
            </p>
            
            <h3>Social Media</h3>
            <p>
              Our website may contain links to social media platforms. We are not 
              responsible for the privacy practices of these external sites.
            </p>
          </section>

          <section className="privacy__section">
            <h2>6. Your Rights</h2>
            <p>
              Under applicable privacy laws, you may have the following rights regarding 
              your personal information:
            </p>
            <ul>
              <li>The right to access your personal data</li>
              <li>The right to rectify or correct inaccurate personal data</li>
              <li>The right to erase your personal data</li>
              <li>The right to restrict processing of your personal data</li>
              <li>The right to data portability</li>
              <li>The right to object to processing of your personal data</li>
            </ul>
            
            <p>
              To exercise these rights, please contact us using the information provided below.
            </p>
          </section>

          <section className="privacy__section">
            <h2>7. Children's Privacy</h2>
            <p>
              Our service does not address anyone under the age of 18. We do not 
              knowingly collect personally identifiable information from children 
              under 18. If you are a parent or guardian and you are aware that your 
              child has provided us with personal data, please contact us.
            </p>
          </section>

          <section className="privacy__section">
            <h2>8. Changes to This Privacy Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you 
              of any changes by posting the new privacy policy on this page and 
              updating the "Last updated" date at the top of this privacy policy.
            </p>
            
            <p>
              You are advised to review this privacy policy periodically for any changes. 
              Changes to this privacy policy are effective when they are posted on this page.
            </p>
          </section>

          <section className="privacy__section">
            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us:
            </p>
            
            <div className="contact-info">
              <div className="contact-item">
                <strong>Company:</strong> {siteConfig.brand.companyName}
              </div>
              <div className="contact-item">
                <strong>Address:</strong> {siteConfig.contact.address.full}
              </div>
              {siteConfig.contact.email && (
                <div className="contact-item">
                  <strong>Email:</strong> 
                  <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
                </div>
              )}
              {siteConfig.contact.phone && (
                <div className="contact-item">
                  <strong>Phone:</strong> 
                  <a href={`tel:${siteConfig.contact.phone}`}>{siteConfig.contact.phone}</a>
                </div>
              )}
            </div>
          </section>

          <div className="privacy__footer">
            <p>
              © {currentYear} {siteConfig.brand.companyName}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;